import { render, staticRenderFns } from "./GlobalCampanhaPanel.vue?vue&type=template&id=32ff11da&scoped=true"
import script from "./GlobalCampanhaPanel.vue?vue&type=script&lang=js"
export * from "./GlobalCampanhaPanel.vue?vue&type=script&lang=js"
import style0 from "./GlobalCampanhaPanel.vue?vue&type=style&index=0&id=32ff11da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ff11da",
  null
  
)

export default component.exports